import { _ as e } from "./index777.mjs";
import { _ as o } from "./index778.mjs";
import { _ as a } from "./index779.mjs";
var n = e, g = o, i = a, T = "[object Null]", b = "[object Undefined]", r = n ? n.toStringTag : void 0;
function f(t) {
  return t == null ? t === void 0 ? b : T : r && r in Object(t) ? g(t) : i(t);
}
var s = f;
export {
  s as _
};
